"use strict";
exports.__esModule = true;
exports.BasketService = void 0;
var session_1 = require("../session");
var operators_1 = require("rxjs/operators");
var http_1 = require("../../core/http");
var basket_api_1 = require("./basket.api");
var model_1 = require("./model");
var store_1 = require("./store");
var store_2 = require("./store");
var basket_helper_service_1 = require("./basket-helper.service");
var rxjs_1 = require("rxjs");
var fetchBasket = function (session) {
    basket_helper_service_1.BasketHelperService.setLoadingInBasket(true);
    return basket_helper_service_1.BasketHelperService.fetchGetBasket(session).pipe(operators_1.first(), operators_1.map(function (basketResponse) {
        var basket = model_1.createBasket(basketResponse, session.display.currency);
        store_1.BasketStore.update(basket);
        basket_helper_service_1.BasketHelperService.setLoadingInBasket(false);
        return basket;
    }), operators_1.catchError(function (err) {
        return rxjs_1.of(err);
    }));
};
var fetchDeleteBasket = function (sessionId) {
    return http_1.Http["delete"](basket_api_1.BasketApi.deleteBasket(sessionId));
};
var setRoomInBasket = function (body) {
    basket_helper_service_1.BasketHelperService.setLoadingInBasket(true);
    return session_1.SessionLoaded$.pipe(operators_1.first(), operators_1.switchMap(function (session) { return rxjs_1.zip(rxjs_1.of(session), basket_helper_service_1.BasketHelperService.fetchSetRoomInBasket(session.sessionId, body)); }), operators_1.switchMap(function (_a) {
        var session = _a[0];
        return basket_helper_service_1.BasketHelperService.updateBasketAndSession(session);
    }), operators_1.catchError(session_1.SessionService.shouldBeSessionError), operators_1.finalize(function () { return basket_helper_service_1.BasketHelperService.setLoadingInBasket(false); }));
};
var setExtraInBasket = function (body) {
    basket_helper_service_1.BasketHelperService.setLoadingInBasket(true);
    return session_1.SessionLoaded$.pipe(operators_1.first(), operators_1.switchMap(function (session) { return rxjs_1.zip(rxjs_1.of(session), basket_helper_service_1.BasketHelperService.fetchSetExtraInBasket(session.sessionId, body)); }), operators_1.switchMap(function (_a) {
        var session = _a[0];
        return basket_helper_service_1.BasketHelperService.updateBasketAndSession(session);
    }), operators_1.catchError(session_1.SessionService.shouldBeSessionError), operators_1.finalize(function () { return basket_helper_service_1.BasketHelperService.setLoadingInBasket(false); }));
};
var getBasket = function (session) {
    if (store_2.BasketQuery.getValue().price) {
        basket_helper_service_1.BasketHelperService.setLoadingInBasket(false);
        return store_2.BasketQuery.select();
    }
    return fetchBasket(session);
};
var deleteBasket = function () {
    basket_helper_service_1.BasketHelperService.setLoadingInBasket(true);
    return session_1.SessionLoaded$.pipe(operators_1.first(), operators_1.switchMap(function (session) { return rxjs_1.zip(rxjs_1.of(session), fetchDeleteBasket(session.sessionId)); }), operators_1.switchMap(function (_a) {
        var session = _a[0];
        return basket_helper_service_1.BasketHelperService.updateBasketAndSession(session);
    }), operators_1.catchError(session_1.SessionService.shouldBeSessionError), operators_1.finalize(function () { return basket_helper_service_1.BasketHelperService.setLoadingInBasket(false); }));
};
var resetCacheFetchGetBasket = function () { return basket_helper_service_1.BasketHelperService.resetCacheFetchGetBasket(); };
exports.BasketService = {
    fetchBasket: fetchBasket,
    fetchDeleteBasket: fetchDeleteBasket,
    getBasket: getBasket,
    setRoomInBasket: setRoomInBasket,
    setExtraInBasket: setExtraInBasket,
    deleteBasket: deleteBasket,
    resetCacheFetchGetBasket: resetCacheFetchGetBasket
};
//# sourceMappingURL=basket.service.js.map